import InputTextArea from "@/components/Input/InputTextArea";
import { CFormItemBase, type CFormItemProps } from "../CFormItem";

export type CFormTextAreaItemProps = CFormItemProps & {
  value?: string;
  onChange: (value?: string) => void;
  disabled?: boolean;
  inputWidth?: number | string;
  readComponent?: React.ReactNode;
  placeholder?: string;
  rows?: number;
  maxLength?: number;
};

export function CFormTextAreaItem({
  id,
  label,
  value,
  onChange,
  errors,
  required,
  inputWidth,
  disabled,
  colSpan,
  placeholder,
  rows = 3,
  maxLength,
  readComponent,
}: CFormTextAreaItemProps) {
  return (
    <CFormItemBase
      id={id}
      label={label}
      errors={errors}
      required={required}
      colSpan={colSpan}
      readComponent={
        <p className="whitespace-pre-wrap">{readComponent ?? value}</p>
      }
      writeComponent={
        <InputTextArea
          id={id}
          value={value ?? ""}
          width={inputWidth ?? "100%"}
          onChange={(e) => onChange?.(e.target.value || undefined)}
          disabled={disabled}
          placeholder={placeholder}
          rows={rows}
          maxLength={maxLength}
        />
      }
    />
  );
}
